export default __webpack_public_path__ + "static/media/main-img.8155c62e.webp";